export const ROLES = [
    { data: "admin", name: "Admin" },
    { data: "manager", name: "Manager" },
    { data: "referrer", name: "Referrer" },
    { data: "sales", name: "Sales" },
    { data: "installer", name: "Installer" }
];


// WEBPACK FOOTER //
// /root/anvel/angular/app/data/roles.ts